import React from "react";
import Form from "../../components/admin/Form";


export default function ViewStudentProfile() {
  return (
    <div className="">
      <Form title={"New Student"} />
    </div>
  );
}

